import { SchemaFormDefinition } from '@mews-commander/form';
import { FormSelectionCardGroupField, lt } from '@mews/framework';
import { Icon, IconName } from '@optimus-web/core';
import { compactArray } from '@mews/fp';
import { updateSchema } from '../schemas/updateSchema';

export const updateFormDefinition = {
    fields: {
        isEnabled: {
            label: lt('Enabled'),
            render: (props) => (
                <FormSelectionCardGroupField
                    type="checkbox"
                    options={[
                        {
                            dataTestId: 'enable-integration',
                            label: lt('Enable'),
                            media: <Icon value={IconName.Connect} variant="basic" />,
                            name: 'enabled',
                            value: 'true',
                        },
                    ]}
                    name={props.name}
                    templateColumns="1fr"
                    defaultValue=""
                />
            ),
        },
        createdUtc: {
            label: lt('CreatedOn'),
            readOnly: true,
            field: {
                type: 'date',
                mode: 'utc',
            },
        },
        updatedUtc: {
            label: lt('UpdatedOn'),
            readOnly: true,
            field: {
                type: 'date',
                mode: 'utc',
            },
        },
    },
} satisfies SchemaFormDefinition<typeof updateSchema>;

export const getUpdateFormDefinition = (hideEnableIntegration = false) =>
    ({
        fields: {
            ...updateFormDefinition.fields,
        },
        renderFields: compactArray([hideEnableIntegration ? null : 'isEnabled', 'createdUtc', 'updatedUtc']),
    }) satisfies SchemaFormDefinition<typeof updateSchema>;
